import type { IconData } from '@stacksjs/iconify-core'

export const travelBus: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 0a3 3 0 0 0-3 3H0v4h2v7a2 2 0 1 0 4 0h4a2 2 0 1 0 4 0V7h2V3h-2a3 3 0 0 0-3-3zm7 3H4v6h8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelBus
